import {
    SET_USER_DATA
} from '../actions/userActions';

const initialState = { 
	user: {}
};

//use switch it's more readable
export const userReducer = (state = initialState, action) => {
	switch (action.type) {
        case SET_USER_DATA.SUCCESS:
			return {
				...state,
				user: action.payload
            };
        case SET_USER_DATA.EMPTY:
            return {
                ...state,
                user: {}
            }    

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js